import React, { useState, useEffect } from 'react';
import { doc, getDoc, collection, getDocs, query, orderBy, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../firebaseConfig';
import { useTheme } from '../context/ThemeContext';
import './Navigation.css';

export default function Navigation() {
  const { colors } = useTheme();
  const [pixBalance, setPixBalance] = useState<number>(0);
  const [loadingBalance, setLoadingBalance] = useState(true);

  useEffect(() => {
    if (!auth.currentUser) {
      setPixBalance(0);
      setLoadingBalance(false);
      return;
    }

    const fetchBalance = async () => {
      try {
        // Get all approved rewards (same as mobile app PixContext)
        const userRef = doc(db, 'users', auth.currentUser!.uid);
        const userSnap = await getDoc(userRef);
        const data = userSnap.data();
        const completedTasks = data?.completedTasks || {};
        let totalEarned = 0;
        
        Object.values(completedTasks).forEach((task: any) => {
          const submissions = Array.isArray(task.submissions) ? task.submissions : [task];
          submissions.forEach((sub: any) => {
            if (sub.status === 'approved') {
              const reward = Number(sub.reward) || Number(sub.rewardAmount) || 0;
              totalEarned += reward;
            }
          });
        });
        
        // Get all withdrawals
        const withdrawalsRef = collection(db, 'users', auth.currentUser!.uid, 'withdrawals');
        const withdrawalsSnap = await getDocs(query(withdrawalsRef, orderBy('createdAt', 'desc')));
        const totalWithdrawn = withdrawalsSnap.docs.reduce((sum, doc) => {
          const data = doc.data();
          return sum + (data.amount || 0);
        }, 0);
        
        setPixBalance(totalEarned - totalWithdrawn);
      } catch (error) {
        console.error('Error fetching PIX balance:', error);
        setPixBalance(0);
      } finally {
        setLoadingBalance(false);
      }
    };

    fetchBalance();

    // Listen for changes
    const userUnsub = onSnapshot(doc(db, 'users', auth.currentUser!.uid), fetchBalance);
    const withdrawalsUnsub = onSnapshot(
      collection(db, 'users', auth.currentUser!.uid, 'withdrawals'),
      fetchBalance
    );

    return () => {
      userUnsub();
      withdrawalsUnsub();
    };
  }, []);

  return (
    <nav className="main-nav" style={{ background: colors.card, borderBottomColor: colors.border }}>
      <div className="nav-container">
        <div style={{ flex: 1 }}></div>
        
        {/* PIX Balance - Upper Right */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ 
            color: colors.primary, 
            fontWeight: 'bold', 
            fontSize: '11px',
            letterSpacing: '1px'
          }}>
            $PIX
          </span>
          <div style={{
            background: colors.primary,
            borderRadius: '14px',
            padding: '2px 8px',
            minWidth: '40px',
            height: '22px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <span style={{
              color: '#fff',
              fontWeight: 'bold',
              fontSize: '13px'
            }}>
              {loadingBalance ? '...' : (pixBalance !== undefined ? pixBalance.toFixed(0) : '--')}
            </span>
          </div>
        </div>
      </div>
    </nav>
  );
}

